import { FC } from 'react';
import { Intercom as IntercomInit } from '@intercom/messenger-js-sdk';

export const Intercom: FC = () => {
  IntercomInit({
    app_id: 'x0boygkw',
  });

  return null;
};

export default Intercom;
